module.exports = __webpack_public_path__ + "data-table.bce071e976865da51100.eot";


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/koraal-mijnmening-backoffice/checkout/node_modules/@swimlane/ngx-datatable/release/assets/fonts/data-table.eot
// module id = ../../../../@swimlane/ngx-datatable/release/assets/fonts/data-table.eot
// module chunks = styles